<template>
  <div id="bg-home">
    <b-img v-if="vmode=='standby' || vmode=='mood-selection'" :src="require('../assets/core/history-icon.svg')" class="history-icon" @click="toggleHistoryPlane"></b-img>
    <div v-if="vmode == 'standby'">
      <div class="standby-container">
        <b-img :src="require('../assets/core/globe-grid-svgrepo-com.svg')" class="globe-icon" @click="changeLanguage" />
        <p class="title-text">{{lang=='en' ? 'Generate Video with your photo!':'이미지를 비디오로 생성해보세요!'}}</p>
        <p>Make your own video with Gen-AI</p>
        <b-button class="import-btn" block size="lg" variant="primary" @click="selectImageFromDevice" style="font-size: 48px; width: 400px;">{{lang=='en' ? 'Load Image':'이미지 선택'}}</b-button>
        <input type="file" accept="image/*" @change="handleFileChange" style="display: none;" ref="fileInputFromDevice" />
      </div>
    </div>
    <div v-if="shouldShowContent">
      <b-img v-b-modal.modal-home :src="require('../assets/core/home-icon-silhouette-svgrepo-com.svg')" class="home-icon" @click="modalGoHome" />
      <MoodSelectionPageView
        v-if="vmode == 'mood-selection'"
        :lang="lang"
        :imageSrc="imageSrc"
        :imageSize="imageSize"
        :imageFileName="imageFileName"
        @generate="handleGenerate"
      />
      <FailedPageView
        v-if="vmode == 'failed'"
        :lang="lang"
        @goHome="goHome"
      />
      <ImageUploadingPageView
        v-if="vmode == 'starting'"
        :lang="lang"
      />
      <ProcessingPageView
        v-if="vmode == 'processing'"
        :lang="lang"
        :percentage="percentage"
      />
      <ProcessingPageView
        v-if="vmode == 'processing-nodigit'"
        :lang="lang"
      />
      <VideoView
        v-if="vmode == 'done'"
        :lang="lang"
        :video-url="video_url"
        :video-loaded="videoLoaded"
        :timestamp-from-history="timestampENFromHistory"
        @goHome="goHome"
        @goFailPage="goFailPage"
      />
    </div>

    <HistoryPlane 
      :shown="isHistoryModalShown"
      :history="history"
      :lang="lang"
      @close="toggleHistoryPlane"
      @play-video="playVideoFromHistory"
      @remove-history="removeOneHistory"
    />
  </div>
</template>

<script>
import axios from 'axios';
import MoodSelectionPageView from '@/features/home/views/MoodSelectionPageView.vue'
import FailedPageView from '@/features/home/views/FailedPageView.vue'
import ProcessingPageView from '@/features/home/views/ProcessingPageView.vue'
import ImageUploadingPageView from '@/features/home/views/ImageUploadingPageView.vue'
import VideoView from '@/features/home/views/VideoView.vue'
import HistoryPlane from '@/components/HistoryPlane.vue'

export default {
  name: 'HomeView',
  components: {
    MoodSelectionPageView
    ,FailedPageView
    ,ProcessingPageView
    ,ImageUploadingPageView
    ,VideoView
    ,HistoryPlane
  },
  data() {
    return {
      lang: 'en',
      // id: "bg-home",
      vmode: 'standby',
      showTop: false,
      percentage: 0,
      imageSrc: '',
      imageFileName: "",
      image: undefined, // raw image file
      imageSize: {},
      loading: undefined,
      task_id: undefined,
      history: [],
      video_url: '',
      remote_api: undefined
      ,videoLoaded: false
      ,isHistoryModalShown: false
      ,enqueuedDateTimeEN: ""
      ,timestampENFromHistory: undefined
    }
  },
  methods: {
    selectImageFromDevice() {
      this.$refs.fileInputFromDevice.click();
    },
    async handleFileChange(event) {
      const file = event.target.files[0]
      this.image = file
      if (file) {
        console.log("Image size: "+file.size)
        if (file.size > 16*1024*1024) {
          console.log("file size exceeds: "+file.size/(1024*1024)+"MB")
          await this.$bvModal.msgBoxOk(this.lang=='en' ? 'File size too big! Reduce to under 16MB.':'크기가 16MB 이하인 파일을 사용하세요.', {
            title: 'Warning',
            size: 'lg',
            buttonSize: 'lg',
            okVariant: 'success',
            centered: true
          })
          return
        }
        this.imageFileName = file.name
        this.imageSrc = URL.createObjectURL(file)
        const img = new Image()
        img.src = this.imageSrc
        img.onload = async () => {
          const aspect_ratio = img.width / img.height
          console.log("너비높이비율: "+img.width+", "+img.height+", "+aspect_ratio)
          this.imageSize = {width: img.width, height: img.height}
          if (img.width < 300 || img.height < 300) {
            await this.$bvModal.msgBoxOk(this.lang=='en' ? 'Image width and height should be over 300 pixels!':'높이/너비가 300 픽셀 이상인 이미지를 첨부하세요.', {
              title: 'Warning',
              size: 'lg',
              buttonSize: 'lg',
              okVariant: 'success',
              centered: true
            })
            return
          }
          // this.id = 'bg-plain'
          this.vmode = 'mood-selection'
        }
      }
      else {
        console.log("File import error!!")
      }
    },
    async modalGoHome() { 
      await this.$bvModal.msgBoxConfirm(this.lang=='en' ? 'Are you sure to go main page?':'정말 메인 화면으로 가시겠습니까?', {
        okVariant: 'danger',
        centered: true
      }).then((value) => {
        if (value == true){
          this.goHome()
        }
      }).catch(e => console.log("Error while modalGoHome: "+e.message))
    },
    goHome() {
      this.task_id = undefined
      this.timestampENFromHistory = undefined
      location.href = "./?lang="+this.lang
    },
    goFailPage() {
      this.vmode = 'failed'
    },
    async handleGenerate({canvasFile: canvasFile, moodData: { mood, moodEN, moodKO }}) {
      this.vmode = 'starting'
      const formData = new FormData()
      formData.append("image", canvasFile)
      formData.append("theme", mood)

      axios({
        method: "post",
        url: `${this.remote_api}/sendImage`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
          'Content-Type': 'multipart/form-data',
        },
        data: formData
      }).then((resp) => {
        const response = resp.data
        this.task_id = response.task_id
        console.log("POST success with task_id returned : "+this.task_id)
        const dt = this.getFormattedDate()
        this.enqueuedDateTimeEN = `${dt[2]}/${dt[1]}/${dt[0]} ${dt[3]}:${dt[4]}:${dt[5]}`
        this.history.push({
          "enqueuedDateTimeEN": this.enqueuedDateTimeEN,
          "enqueuedDateTimeKO": `${dt[0]}년 ${dt[1]}월 ${dt[2]}일 ${dt[3]}:${dt[4]}:${dt[5]}`,
          "fileName": this.imageFileName,
          "moodEN": moodEN,
          "moodKO": moodKO,
          "taskId": this.task_id,
          "videoUrl": null,
          "videoEverShown": false
        })
        while (this.history.length > 20) {
          this.history.shift()
        }
        localStorage.setItem('photolink_history', JSON.stringify(this.history))
        this.vmode = 'processing'
      }).catch((e) => {
        console.log("Error while POST!! : "+e.message)
        this.vmode = 'failed'
        this.task_id = undefined
      })
    },
    async getSchedule() {
      console.log("Interval start")
      if (this.vmode == 'done') {
        clearInterval(this.loading)
        return
      }
      if (this.vmode != 'processing' && this.vmode != 'processing-nodigit') return
      if (this.task_id == null) {
        console.log("processing phase BUT task_id is empty!! could not request POST makeVideo")
        this.vmode = 'failed'
        return
      }


      axios({
        method: "post",
        url: `${this.remote_api}/makeVideoUrl`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        },
        data: { task_id: this.task_id }
      }).then(({data}) => {
        console.log("Response of req video is: "+JSON.stringify(data))
        if (data != undefined) {
          if (data.generation_progress == 'Fail') {
            console.log("Response of req video 'generation_progress' returns 'Fail'.")
            clearInterval(this.loading)
            this.vmode = 'failed'
            this.history = this.history.filter(i => i.enqueuedDateTimeEN !== this.enqueuedDateTimeEN)
            localStorage.setItem('photolink_history', JSON.stringify(this.history))
            this.task_id = undefined
          }
          else if (data.generation_progress == 'Success' && (this.vmode == 'processing' || this.vmode == 'processing-nodigit')) {
            clearInterval(this.loading)
            this.task_id = undefined
            this.video_url = data.video_url
            const index = this.history.findIndex((item) => item.enqueuedDateTimeEN === this.enqueuedDateTimeEN)
            this.history[index].videoUrl = this.video_url
            this.history[index].videoEverShown = true
            localStorage.setItem('photolink_history', JSON.stringify(this.history))
            this.percentage = 100
            setTimeout(() => {
              this.vmode = 'done'
              this.videoLoaded = true
            }, 700)
            // setTimeout(() => {this.videoLoaded = true}, 1800)
          }
          else {
            const inc = 7 + Math.floor(Math.random() * 5) // 7 ~ 11 random number
            this.percentage = (this.percentage + inc < 100) ? this.percentage + inc : this.percentage
            console.log("Loading progress: "+this.percentage+" %")
          }
        } else {
          console.log("Response of req video is null. response data below:")
          console.log(data)
          clearInterval(this.loading)
          this.vmode = 'failed'
          this.history = this.history.filter(i => i.enqueuedDateTimeEN !== this.enqueuedDateTimeEN)
          localStorage.setItem('photolink_history', JSON.stringify(this.history))
          this.task_id = undefined
        }
      }).catch((e) => {
        console.log("Error while makeVideoUrl!! : "+e.message)
        clearInterval(this.loading)
        this.vmode = 'failed'
      })
    }
    ,changeLanguage() {
      if (this.lang == 'ko') {
        location.href = './?lang=en'
      }
      else if (this.lang == 'en') {
        location.href = './?lang=ko'
      }
    }
    ,toggleHistoryPlane() {
      this.isHistoryModalShown = !this.isHistoryModalShown
    }
    ,getFormattedDate(){
      const date = new Date()
      const Y = String(date.getFullYear()).padStart(4, "0")
      const M = String(date.getMonth() + 1).padStart(2, "0")
      const D = String(date.getDate()).padStart(2, "0")
      const h = String(date.getHours()).padStart(2, "0")
      const m = String(date.getMinutes()).padStart(2, "0")
      const s = String(date.getSeconds()).padStart(2, "0")

      return [Y, M, D, h, m, s]
    }
    ,playVideoFromHistory(uri, timestampEN) { // replay video from history plane
      this.video_url = uri
      // this.id = 'bg-plain'
      this.vmode = 'done'
      this.videoLoaded = true
      this.toggleHistoryPlane()
      this.timestampENFromHistory = timestampEN
    }
    ,async removeOneHistory(timestampEN) {
      await this.$bvModal.msgBoxConfirm(this.lang=='en' ? 'Are you sure to remove history?':'기록을 삭제할까요?', {
        okVariant: 'danger',
        centered: true
      }).then((value) => {
        if (value === true){
          let history = this.history
          history = history.filter(i => i.enqueuedDateTimeEN !== timestampEN)
          localStorage.setItem('photolink_history', JSON.stringify(history))
          this.history = JSON.parse(localStorage.getItem('photolink_history'))
        }
      })
    }
  },

  async mounted() {
    this.remote_api = process.env.VUE_APP_DEMOSERVER_REMOTE
    this.loading = setInterval(this.getSchedule, 1000) // check if video available every 1 seconds
    if (this.$route.query.lang != null) {
      this.lang = this.$route.query.lang
    }
    console.log("현재 언어: "+this.lang)

    let historyFromLocalStorage = JSON.parse(localStorage.getItem('photolink_history'))
    // console.log(historyFromLocalStorage)
    // console.log(typeof(historyFromLocalStorage))
    if (historyFromLocalStorage) { // load if history is available from browser
      this.history = historyFromLocalStorage
      for (let i = 0; i < historyFromLocalStorage.length; i++) {
        // console.log(historyFromLocalStorage[i])
        if (historyFromLocalStorage[i].videoEverShown === false) { // reload when unshown record is detected
          this.task_id = historyFromLocalStorage[i].taskId
          this.enqueuedDateTimeEN = historyFromLocalStorage[i].enqueuedDateTimeEN
          await this.$bvModal.msgBoxConfirm(this.lang=='en' ? 'Unfinished task found. Would you resume generating video?':'생성중인 동영상이 있습니다. 이어서 진행할까요?', {
            okVariant: 'primary',
            centered: true
          }).then((value) => {
            if (value === true){
              this.vmode = 'processing-nodigit'
              // this.id = 'bg-plain'
            } else { // remove the corresponding history
              let history = this.history
              history = history.filter(i => i.enqueuedDateTimeEN !== this.enqueuedDateTimeEN)
              localStorage.setItem('photolink_history', JSON.stringify(history))
              this.goHome() // refresh
            }
          })
          break
        }
      }
    } else {
      // Sample localstorage - if needed, assign it instead of empty list '[]'
      let sample = []
      sample.push({
        "enqueuedDateTimeEN": "17/02/2025 08:38:28",
        "enqueuedDateTimeKO": "2025년 02월 17일 08:38:28",
        "fileName": "Cat_in_front_of_Christmas_tree.jpg",
        "moodEN": "Christmas",
        "moodKO": "크리스마스",
        "taskId": "xxxxxxxx-d671-482d-9ef6-f204aba61db5",
        "videoUrl": "https://mildly-peaceful-killdeer.ngrok-free.app/v1/photoLink/videos/10f810c1-94ba-4c04-b650-2432ee7c8571.mp4",
        "videoEverShown": true
      })
      sample.push({
        "enqueuedDateTimeEN": "18/02/2025 08:41:50",
        "enqueuedDateTimeKO": "2025년 02월 18일 08:41:50",
        "fileName": "cloud_flows.jpg",
        "moodEN": "Moody",
        "moodKO": "분위기 있는",
        "taskId": "xxxxxxxx-51d8-4515-af23-f7db2c8be305",
        "videoUrl": "https://mildly-peaceful-killdeer.ngrok-free.app/v1/photoLink/videos/a42cddbb-0577-45f0-80d5-a1ae69596ed9.mp4",
        "videoEverShown": true
      })
      sample.push({
        "enqueuedDateTimeEN": "18/02/2025 09:00:50",
        "enqueuedDateTimeKO": "2025년 02월 18일 09:00:50",
        "fileName": "Camp_Fire.jpg",
        "moodEN": "Happy",
        "moodKO": "행복",
        "taskId": "xxxxxxxx-7581-4d30-be81-d52ead337079",
        "videoUrl": "https://mildly-peaceful-killdeer.ngrok-free.app/v1/photoLink/videos/campfire.mp4",
        "videoEverShown": true
      })
      localStorage.setItem('photolink_history', JSON.stringify(sample))
      // localStorage.setItem('photolink_history', JSON.stringify([]))
    }
  },
  computed: {
    shouldShowContent() {
      return ['mood-selection', 'starting', 'processing', 
              'processing-nodigit', 'done', 'failed'].includes(this.vmode)
    }
  }
}
</script>

<style scoped>
#bg-home {
  width: 1800px; 
  height: 720px;
  overflow:hidden;
  margin: 0px;
  /* background-image: url('../assets/ihu/bg-min.png');
  background-size: cover;
  background-repeat: repeat; */
  background-color: #FAFAFA; /* #F5F6F6 */
  padding: 0px 0px; /* Need to be fixed */
}
#bg-home > div {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.standby-container{
  display: flex;
  flex-direction: column;
}
.import-btn {
  margin: auto;
}

</style>
